import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { RegionProvider } from './context/RegionContext';
import { EditModeProvider } from './context/EditModeContext';
import AppRoutes from './AppRoutes';
import FloatingSaveButton from './components/EditableText/FloatingSaveButton';
import './App.css';

function App() {
  return (
    <Router>
      <LanguageProvider>
        <RegionProvider>
          <EditModeProvider>
            <div className="App">
              <AppRoutes />
              <FloatingSaveButton />
            </div>
          </EditModeProvider>
        </RegionProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;